
import * as React from 'react';
import { useState } from 'react';

type LabelProps = {
    Text: string;
    InLine?: boolean;
}

export const SaLabel: React.FunctionComponent<LabelProps> = (props: LabelProps) => {
    props = { ...{InLine:false}, ...props }
    return (<span className="swLabel">{props.Text} { props.InLine ? "" :<br/>} </span>);
}

type SaDateProps = { Value: string|undefined;}

export const SaDate: React.FunctionComponent<SaDateProps> = (props: SaDateProps) => {
    if (typeof props.Value == "undefined" || props.Value=="" || props.Value == null) {
        return (<span></span>);
    } else {        
        return (<span>{new Date(props.Value).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })}</span>);
    }
}

type SaCurrencyProps = { Amount: number }

export const SaCurrency: React.FunctionComponent<SaCurrencyProps> = (props: SaCurrencyProps) => {

    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });


    return (<span>{formatter.format(props.Amount)}</span>);
}

type SaPhoneProps = { UnformattedPhone: string }

export const SaPhone: React.FunctionComponent<SaPhoneProps> = (props: SaPhoneProps) => {

    var phoneFormatted: string = "";   
    if (props.UnformattedPhone && props.UnformattedPhone.length == 10) {
        phoneFormatted = `${props.UnformattedPhone.substr(0, 3)} ${props.UnformattedPhone.substr(3, 3)} ${props.UnformattedPhone.substr(6, 4)} `;
    } else {
        phoneFormatted = props.UnformattedPhone;
    }

    

    return (<span>{phoneFormatted}</span>);
}

export type SaLongTextProps = { OriginalText: String, CutTextToPosition: number };

export const SaLongText: React.FunctionComponent<SaLongTextProps> = (props: SaLongTextProps) => {

    const [displayFullText, updatedisplayFullText] = useState<boolean>(false);

    function switchValue() {
        updatedisplayFullText(!displayFullText);
    }

    if (props.OriginalText&& (props.OriginalText.length > props.CutTextToPosition)) {

        if (displayFullText) {
            return (<span>{props.OriginalText}<a onClick={switchValue} style={{ color: "blue", cursor: "pointer" }}> less</a></span>);
        } else {
            return (props.OriginalText && (<span>{props.OriginalText.substr(0, props.CutTextToPosition)}<a onClick={switchValue} style={{ color: "blue", cursor: "pointer" }}> more</a></span>));
        }
    } else {
        return (<span>{props.OriginalText}</span>);
    }

    
}